<template>
  <div>
    <dea-top-header show-mondo-deascuola section="Area Personale" class="dea-top-header--deascuola"></dea-top-header>
    <div id="myhome" class="myhome-main site-main main-content">
      <router-view
        :main-logos="mainLogos"
        :show-modal-error="showModalError"
        @display-menu="showMenu = true"
      ></router-view>
    </div>
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions, mapGetters } from "vuex";
import utils from "@/components/mixins/utils";
import asyncConfig from "@/components/mixins/asyncConfig";
import staticAutosuggestData from "@/components/mixins/staticAutosuggestData";
import Schools from "./clients/schools";

export default {
  name: "MyHomeApp",
  mixins: [asyncConfig, staticAutosuggestData],
  data() {
    document.title = "Area Personale";
    return {
      returnUrl: "",
      orderId: null,
      showModalError: false,
      showMenu: false,
      mainLogos: [
        {
          src: "img/logo/dea/dea_vertical.svg",
          className: "svg-logo dea-header--center__logo svg-logo--dea--vertical",
        },
        {
          src: "img/logo/dea/dea_horizontal.svg",
          className: "svg-logo dea-header--center__logo svg-logo--dea--horizontal",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["user", "config", "order", "messagesList"]),
  },
  watch: {
    // call again the method if the route changes
    $route: "updateRegistrations",
  },
  created() {
    window.headerApp = this;
    try {
      this.$root.data.config = this.config;
    } catch {
      this.$root.data = { config: this.config };
    }
    const token = this.$cookies.get(this.config.api.tokenName);
    const redirected = this.$cookies.get("dea-redirected");
    const urlParams = new URLSearchParams(window.location.search);
    this.orderId = urlParams.get("order_id");
    const secure = document.location.protocol === "https:" && this.$root.config.useSecureCookie;
    if (!token && !redirected) {
      this.$cookies.set("dea-redirected", true, "0", "/", ".deascuola.it", secure, "Lax");
      utils.redirectToLogin(null, this.config);
    } else if (!token && redirected) {
      this.showModalError = true;
      setTimeout(() => {
        document.location = this.$root.config.logout_url;
      }, this.$root.config.loadingErrorTimeout);
    } else {
      this.$cookies.set("dea-redirected", false, "0", "/", ".deascuola.it", secure, "Lax");
      if (!this.order.id) this.fetchCartOrder(this.orderId);
      this.fetchRegistrations();
      this.fetchBookmarks(token);

      Schools.getClusters(this.$root.config)
        .then(data => {
          sessionStorage.setItem("clusters", JSON.stringify(data));
        })
        .catch(e => {
          Sentry.captureException(e);
        });
    }
  },
  mounted() {
    const returnCookie = this.$cookies.get("formazioneReturnUrl");
    if (returnCookie) this.returnUrl = returnCookie;
    else this.returnUrl = this.config.public_url;
  },
  methods: {
    ...mapActions(["fetchOrder", "fetchUser", "confirmData", "fetchRegistrations", "fetchCartOrder", "fetchBookmarks"]),
    updateRegistrations() {
      if (this.$route.params.updateRegistrations) {
        this.fetchRegistrations();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_local-variables"; //sass-lint:disable-line clean-import-paths

.myhome-main {
  min-height: 100vh;
}

.main-container {
  padding-bottom: 120px;
}
</style>
